import { __assign, __rest } from "tslib";
import { useContext } from 'react';
import { OverlayContextProvider, OverlayContext, overlayContextDefaults, } from '@wix/da-react-context/pkg/OverlayContext';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import { useDeviationAttributes } from './useDeviationAttributes';
/** almost same as useContext(OverlayContext), but with correct defaults */
export function useOverlayContext(deviation) {
    var _a = useDeviationAttributes(deviation, false), isFavouritable = _a.isFavouritable, isCommentable = _a.isCommentable;
    var deviationType = getDeviationType(deviation);
    var canShowTitle = ![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
        DeviationTypes.POLL,
        DeviationTypes.STATUS,
    ].includes(deviationType);
    var rawContext = useContext(OverlayContext);
    var _b = __assign(__assign({}, overlayContextDefaults), rawContext), showTitle = _b.showTitle, showFaveControl = _b.showFaveControl, showCommentControl = _b.showCommentControl, showFaveEngagementIcon = _b.showFaveEngagementIcon, showCommentEngagementIcon = _b.showCommentEngagementIcon, restContext = __rest(_b, ["showTitle", "showFaveControl", "showCommentControl", "showFaveEngagementIcon", "showCommentEngagementIcon"]);
    return __assign({ showTitle: canShowTitle && showTitle, showFaveControl: isFavouritable && showFaveControl, showCommentControl: isCommentable && showCommentControl, showFaveEngagementIcon: isFavouritable && showFaveControl && showFaveEngagementIcon, showCommentEngagementIcon: isCommentable && showCommentControl && showCommentEngagementIcon }, restContext);
}
export { OverlayContextProvider };
//# sourceMappingURL=useOverlayContext.js.map